import React, { Fragment, useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import Grid from "@material-ui/core/Grid";
import Paper from "@material-ui/core/Paper";
import Box from "@material-ui/core/Box";
import Typography from "@material-ui/core/Typography";
//Custom Component
import PasDetails from "./pasSection/pasDetails";
// Material-UI Core
import { makeStyles, withStyles } from "@material-ui/core/styles";
// Custom Style
import { pasDetailFormStyle } from "../../../styles/jss/components/PAS/pasDetailFormStyle";
const useStyles = makeStyles((theme) => pasDetailFormStyle(theme));
const PASDetailsForm = (props) => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const { pasDetails, saleEditorValue, progressEditorValue } = props;

  return (
    <Fragment>
      <Grid container spacing={1}>
        <Paper variant="outlined" elevation={6}>
          <div style={{ margin: "10px" }}>
            <Grid item xs={12}>
              {pasDetails && (
                <PasDetails
                  pasDetails={pasDetails}
                  saleEditorValue={saleEditorValue}
                  progressEditorValue={progressEditorValue}
                />
              )}
            </Grid>
            <Grid item xs={12}>
              <Typography variant="subtitle2">
                Last Update Date:
                <div className={classes.itemText}>
                  {pasDetails.details && pasDetails.details.modifydate}
                </div>
              </Typography>
            </Grid>
            <Grid item xs={12}>
              <Typography variant="subtitle2">
                Last Update By:
                <div className={classes.itemText}>
                  {pasDetails.details && pasDetails.details.modifyuser}
                </div>
              </Typography>
            </Grid>
          </div>
        </Paper>
      </Grid>
    </Fragment>
  );
};

export default PASDetailsForm;
